import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/thumbs-up-off.svg'
import _imports_1 from '@/assets/images/thumbs-up-on.svg'


const _withScopeId = n => (_pushScopeId("data-v-227fb072"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("一覧へ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "info color-info" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "color-success" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "14",
  height: "14",
  class: "image-position"
}, null, -1))
const _hoisted_8 = { class: "color-success" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "14",
  height: "14",
  class: "image-position"
}, null, -1))
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_12 = { class: "comment-box mt20" }
const _hoisted_13 = { class: "mt10 mb10 text-right" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("送信")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "info color-info" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { class: "body" }
const _hoisted_19 = { class: "comment-iine" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "14",
    height: "14",
    class: "image-position"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "14",
    height: "14",
    class: "image-position"
  })
], -1))
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "mt5 text-right" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "削除しますか？")
], -1))
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("削除 ")

import { onMounted, ref, computed } from 'vue'
import { useStore } from "vuex";
import { useRoute } from 'vue-router'
import { TimeLineLogic } from '@/logic/time_lines/TimeLineLogic'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { get, iine, cancelIine, comment, deleteComment, time_line, updateComment, commentIine, commentCancelIine, timeLineLoading } = TimeLineLogic();
const route = useRoute();
const commentBody = ref('')
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
let user_id = computed(() => store.state.login.user_id);
const deleteCommentConfirmDialogVisible = ref(false)
const delateCommentId = ref(0)

onMounted(async (): Promise<void> => {
  get(Number(route.params.time_line_id))
});

const sendComment = async () => {
  if (!time_line.value) {
    return
  }
  await comment(time_line.value.id, commentBody.value)
  commentBody.value = ''
}
const delateConfirmComment = (comment_id: number) => {
  delateCommentId.value = comment_id
  deleteCommentConfirmDialogVisible.value = true
}
const updateSaveComment = () => {
  if (!time_line.value) {
    editCommentId.value = 0
    return
  }
  updateComment(time_line.value.id, editCommentId.value, editCommentBody.value)
  editCommentId.value = 0

}
const editCommentId = ref(0)
const editCommentBody = ref('')
const changeEditMode = (comment_id: number, body: string) => {
  editCommentId.value = comment_id
  editCommentBody.value = body


}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: { name: 'TimeLines', params: { project_id: _ctx.$route.params.project_id } },
        class: "button-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      (_unref(time_line))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(time_line).user_name) + " ", 1),
                _createElementVNode("span", _hoisted_4, "投稿日:" + _toDisplayString(_unref(time_line).post_at), 1)
              ]),
              _createElementVNode("div", {
                class: "body mt10 mb10",
                innerHTML: _unref(time_line).body
              }, null, 8, _hoisted_5),
              _createElementVNode("div", null, [
                _createVNode(_component_el_popover, {
                  placement: "top-start",
                  width: 200,
                  trigger: "hover",
                  disabled: _unref(time_line).iine_count == 0
                }, {
                  reference: _withCtx(() => [
                    (_unref(time_line).iine == false)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(iine)(_unref(time_line).id)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, [
                              _hoisted_7,
                              _createTextVNode(" " + _toDisplayString(_unref(time_line).iine_count), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(time_line).iine == true)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(cancelIine)(_unref(time_line).id)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, [
                              _hoisted_9,
                              _createTextVNode(" " + _toDisplayString(_unref(time_line).iine_count), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_line).iine_users, (user, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        class: "iine-user"
                      }, _toDisplayString(user.user_name), 1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_unref(time_line).user_id == _unref(user_id) || _unref(managerFlg))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'TimeLineEdit', params: { project_id: _ctx.$route.params.project_id, time_line_id: _unref(time_line).id } },
                    class: "button-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_input, {
          modelValue: commentBody.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commentBody).value = $event)),
          maxlength: "1000",
          placeholder: "Please input",
          rows: "5",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: sendComment,
            disabled: commentBody.value.length == 0
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_line)?.time_line_comments, (time_line_comment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: time_line_comment.id,
            class: "mb10"
          }, [
            _createVNode(_component_el_card, { shadow: "none" }, {
              default: _withCtx(() => [
                (editCommentId.value != time_line_comment.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(time_line_comment.user_name) + " ", 1),
                        _createElementVNode("span", _hoisted_17, "投稿日:" + _toDisplayString(time_line_comment.post_at), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(time_line_comment.body), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createTextVNode(_toDisplayString(time_line_comment.iine_count) + "人がいいねしてます ", 1),
                        (time_line_comment.iine == false)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "text",
                              onClick: ($event: any) => (_unref(commentIine)(_unref(time_line).id, time_line_comment.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (time_line_comment.iine == true)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "text",
                              onClick: ($event: any) => (_unref(commentCancelIine)(_unref(time_line).id, time_line_comment.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "text",
                          onClick: ($event: any) => (changeEditMode(time_line_comment.id, time_line_comment.body))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 2
                        }, 1032, ["onClick"]), [
                          [_vShow, time_line_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                        ]),
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "text",
                          onClick: ($event: any) => (delateConfirmComment(time_line_comment.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 2
                        }, 1032, ["onClick"]), [
                          [_vShow, time_line_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_el_input, {
                        modelValue: editCommentBody.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editCommentBody).value = $event)),
                        maxlength: "1000",
                        placeholder: "Please input",
                        rows: "5",
                        "show-word-limit": "",
                        type: "textarea"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "primary",
                          onClick: updateSaveComment
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 2
                        }, 1536), [
                          [_vShow, time_line_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                        ]),
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "text",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (editCommentId.value = 0))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 2
                        }, 1536), [
                          [_vShow, time_line_comment.user_id == _unref(user_id) || _unref(managerFlg)]
                        ])
                      ])
                    ]))
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createVNode(_component_el_dialog, {
        title: "削除確認",
        modelValue: deleteCommentConfirmDialogVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((deleteCommentConfirmDialogVisible).value = $event)),
        width: "30%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_30, [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteCommentConfirmDialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => {deleteCommentConfirmDialogVisible.value = false; _unref(deleteComment)(_unref(time_line).id, delateCommentId.value)})
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _unref(timeLineLoading)]
  ])
}
}

})